var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$.current_panel },
    [
      _c("columns-bar-header", {
        attrs: {
          title: _vm.locales("columns_bar_current_title"),
          "view-config": _vm.viewConfig,
          tabs: _vm.tabs,
          "back-button": false,
          "help-button": true,
        },
        on: {
          onChangeTab: _vm.changeTab,
          onClose: _vm.onClose,
          helpIconClick: _vm.helpIconClick,
        },
      }),
      _vm._v(" "),
      _c(_vm.currentComponent, {
        key: _vm.currentComponent,
        tag: "component",
        attrs: {
          columns: _vm.columns,
          "focused-column-id": _vm.viewConfig.focusedColumnId,
          "is-editable": _vm.viewConfig.editable,
          "is-archived": _vm.viewConfig.isArchivedProject,
        },
        on: {
          onCreateNewColumnClick: function ($event) {
            return _vm.$emit("onCreateNewColumnClick")
          },
          onUseExistedColumnClick: function ($event) {
            return _vm.$emit("onUseExistedColumnClick")
          },
          openEditBar: function (data) {
            return _vm.$emit("openEditBar", data)
          },
          onDeleteClick: function (data) {
            return _vm.$emit("onDeleteClick", data)
          },
          changeCheckbox: _vm.changeCheckbox,
          changeCheckboxOption: function (data) {
            return _vm.$emit("changeCheckboxOption", data)
          },
          redirectToSettings: function ($event) {
            return _vm.$emit("redirectToSettings")
          },
          showGradient: _vm.showGradient,
        },
      }),
      _vm._v(" "),
      _c("gradient", {
        attrs: {
          show:
            _vm.isShowGradient && _vm.currentComponent === "standartColumns",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }